import { create } from 'zustand'

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info'

interface Toast {
  id: number
  message: string
  severity: ToastSeverity
  duration: number
}

interface ToastState {
  toasts: Toast[]
  add: (message: string, severity: ToastSeverity, duration?: number) => void
  remove: (id: number) => void
}

let nextId = 0

export const useToastStore = create<ToastState>()((set) => ({
  toasts: [],
  add: (message, severity, duration = 4000) => {
    const id = ++nextId
    set((s) => ({ toasts: [...s.toasts, { id, message, severity, duration }] }))
  },
  remove: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
  },
}))

/** Convenience helpers — callable from anywhere (Axios interceptors, utils, etc.) */
export const toast = {
  success: (message: string, duration?: number) =>
    useToastStore.getState().add(message, 'success', duration),
  error: (message: string, duration?: number) =>
    useToastStore.getState().add(message, 'error', duration ?? 6000),
  warning: (message: string, duration?: number) =>
    useToastStore.getState().add(message, 'warning', duration),
  info: (message: string, duration?: number) =>
    useToastStore.getState().add(message, 'info', duration),
}
